<template>
<div id="scrollTemp">
  <div class="d-flex bg-white rounded mx-auto overflow-auto my-2 scroll-example" id="scrollTempDiv" style="position: sticky;top: 45px;box-shadow: 0 0 1px black;padding-top: .15em;padding-bottom: .15em;z-index: 899;">
    <button class="px-3 my-font py-2 group-title" v-for="(item, index) in props.products" :key="index" :href="'#group' + item.id" :id="'group' + item.id + 'title'"  @click="goOnPage($event, item.id)">
        <img :src="'https://radap.ir/' + item.src" width="50" v-if="item.src" />
        {{ item.name }}
    </button>
  </div>
  <section class="group-item" v-for="item in props.products" :key="item.id" :data-group-id="item.id" :id="'group' + item.id" >
    <div class="my-2">
      <p class="ps-1" style="font-weight: 600;font-size: 18px;">{{ item.name }}</p>
      <small class="ps-1" style="font-size: small;">{{ item.description }}</small>
    </div>
    <div class="article-template">
      <article class="d-flex align-items-top px-1 py-3 border-bottom border-end position-relative" style="background-color: white;" v-for="(bitem,index) in item.items" :key="bitem.id" >
          <img :src="'https://radap.ir/' + bitem.img_url.split(',')[0]" style="width:25%;max-width: 100px;max-height: 100px;" class="rounded" @click="goProductPage(bitem.id)" />
          <div style="width:75%" class="px-2 product-info-temp">
            <div class="d-flex justify-content-between" style="height: 30px;">
              <p style="max-height: 30px; font-size: 16px;font-weight: 600;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;" @click="goProductPage(bitem.id)">{{ bitem.name}}</p>
              <button-template :id="bitem.id" :sid="bitem.store_place_id" :quantity="bitem.quantity" origin="basket" v-if="item.store_active == 0" />
              <span v-else class="text-light px-1 bg-red  rounded d-flex bg-secondary" style="height: 24px;justify-content: center;align-items: center;font-size: 10px;width:fit-content;min-width:fit-content;left:0">فروشگاه بسته است</span>
            </div>
              <small class="pt-1 d-block description-temp"  v-if="bitem.description" @click="goProductPage(bitem.id)">{{ bitem.description}}</small>
              <footer class=" d-flex justify-content-between align-items-center" @click="goProductPage(bitem.id)">
                <div class="d-flex flex-wrap mt-1">
                  <del class="text-muted" style="margin-left: 5px;font-size: 14px;" v-if="bitem.discount > 0">{{convertToPersian(String(bitem.price)) }}</del>
                  <strong style="margin-left: 5px; border: 1px solid red; border-radius: 5px; padding: 2px; color: red;font-size: 14px;" v-if="bitem.discount > 0"  :class="{ 'peculiar-discount': bitem.discount > 4 }"><small style="font-size: smaller;">%</small>{{convertToPersian(String(bitem.discount)) }}</strong>
                  <strong style="margin-left: 5px;font-size: 14px">{{convertToPersian(numberFormat((parseInt(removeCommos(bitem.price)) - (parseInt(removeCommos(bitem.price)) * (parseInt(bitem.discount) / 100)))))}}<small class="pr-1" style="font-size: 12px">تومان</small></strong>
                </div>
              </footer>
          </div>
      </article>
    </div>

  </section>
</div>
</template>
<script setup>
import { ref,defineProps, onMounted, onUnmounted } from 'vue';
import ButtonTemplate from '../../item/button.vue'
import { convertToPersian, numberFormat, removeCommos } from '@/composables/digits';
import { useRouter } from 'vue-router';
let props = defineProps(['products','damp']);
let router = useRouter()
import { useModal } from '@/store/modal';
const modalStore = useModal();
onMounted(()=>{
  window.scrollTo({
    top: 0,
    behavior: "auto",
  });
})
function goProductPage(id){
  modalStore.open('productModal')
  modalStore.paylode.id = id
    // router.push({name:'Single',params:{item:id}})
}

let classFlage = ref(false);
function goOnPage(e, id) {
  if (classFlage.value != false) {
    document.getElementsByClassName("active")[0].classList.remove("active");
  }
  classFlage.value = true;
  // e.target.classList.add("active");
  var element = document.getElementById("group" + id);
  var headerOffset = 150;
  var elementPosition = element.getBoundingClientRect().top;
  var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
  offsetPosition += 30;
  window.scrollTo({
    top: offsetPosition,
    behavior: "auto",
  });
}
// تعریف کردن ایونت اسکرول برای انتخاب گروه های تیتر بصورت پیش فرض
document.addEventListener("scroll", getActiveGroup);
onUnmounted(() => {
  // حذف ایونت اسکرول بعداز بستن صفحه
  document.removeEventListener("scroll", getActiveGroup);
});

function getActiveGroup() {
  let pageScroll = window.scrollY;
  let elemPos;
  let id;
  document.querySelectorAll(".group-item").forEach((elem, index) => {
    elemPos = Math.round(elem.getBoundingClientRect().top) + pageScroll - 140;
    id = elem.id;
    console.log(id);
    if (pageScroll > elemPos) {
      document.querySelectorAll(".active").forEach((item) => {
        item.classList.remove("active");
      });
      if (document.getElementById(id + "title")) {
        document.getElementById(id + "title").classList.add("active");
        goOnPage2();
      }
    }
  });
}
function goOnPage2() {
  var element = document.querySelector(".active");
  var offsetPosition = element.offsetLeft - 100;
  offsetPosition += 10
  document.getElementById("scrollTempDiv").scrollTo({
    left: offsetPosition,
    behavior: "smooth",
  });
}
</script>
<style scoped>
@media (min-width :570px){
  .product-info-temp{
    width: 100% !important;
  }
}
.active {
  background-color: black !important;
  color:white !important;
}
.description-temp{
  text-align: justify;
  padding-left: .25em;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 40px;
   font-size: 13px;
   -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

}
.group-title{
  color:black;
  min-width: fit-content;
  cursor: pointer;
  border: none;
  background-color: transparent;
  height: 40px;
  font-weight: 600;
  border-radius: 2em !important;
  font-size: 14px;
}
article{
  width: 100%;
}
@media (min-width : 650px){
  .article-template{
    display: flex;
    flex-wrap: wrap;
  }
  article{
    width: 50%;
  }
}
</style>